import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Grid,
  Button,
} from "@mui/material";
import { useState, useEffect } from "react";

export default function GuestForm({ open, onClose, mode, data, onSave }) {
  // Local Form State
  const [form, setForm] = useState({
    fname: "",
    lname: "",
    email: "",
    phone: "",
    address: "",
    state: "",
    id: null,
  });

  // Reset form on open
  useEffect(() => {
    if (open) {
      setForm({
        fname: data?.fname || "",
        lname: data?.lname || "",
        email: data?.email || "",
        phone: data?.phone || "",
        address: data?.address || "",
        state: data?.state || "",
        id: data?.id || null,
      });
    }
  }, [open, data]);

  // Input Change Handler
  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  // Save and close
  const handleSave = () => {
    onSave(form);
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3 } }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>
        {mode === "add" ? "Add Guest" : "Edit Guest"}
      </DialogTitle>

      <DialogContent dividers sx={{ bgcolor: "#fafbfd", p: 3 }}>
        {/* FORM FIELDS */}
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} sm={6}>
            <TextField
              label="First Name"
              fullWidth
              value={form.fname}
              size="small"
              onChange={(e) => handleChange("fname", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Last Name"
              fullWidth
              value={form.lname}
              size="small"
              onChange={(e) => handleChange("lname", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Email"
              fullWidth
              size="small"
              value={form.email}
              onChange={(e) => handleChange("email", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="Phone"
              fullWidth
              size="small"
              value={form.phone}
              onChange={(e) => handleChange("phone", e.target.value)}
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Address"
              fullWidth
              size="small"
              value={form.address}
              onChange={(e) => handleChange("address", e.target.value)}
            />
          </Grid>

          <Grid item xs={12} sm={6}>
            <TextField
              label="State"
              fullWidth
              size="small"
              value={form.state}
              onChange={(e) => handleChange("state", e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} sx={{ textTransform: "none" }}>
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleSave}
          sx={{ textTransform: "none" }}
        >
          Save Guest
        </Button>
      </DialogActions>
    </Dialog>
  );
}
